(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pd-back-to-top"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const backToTop = document.querySelector('.back-to-top');
    const rootElement = document.documentElement;
    const wrapper = document.getElementById(backToTop.dataset.id);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            wrapper.classList.add('d-none');
          } else {
            wrapper.classList.remove('d-none');
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      }
    );

    observer.observe(rootElement);

    backToTop.addEventListener('click', (e) => {
      rootElement.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
